import { FILTERS } from '../../../constants';

const isFilterVisible = ({ type }) => type !== FILTERS.TYPES.HIDDEN;

const getVisibleFilters = (appliedFilters = []) => appliedFilters?.filter(isFilterVisible);

export { getVisibleFilters };
